<div fxLayout="column"
  fxLayoutGap="10px"
  fxLayout.gt-md="row"
  fxLayoutAlign.gt-md="start center"
  fxLayoutGap.gt-md="0px">

  <div fxFlex="grow"
    fxLayout="column"
    fxLayoutGap="10px"
    fxLayout.gt-md="row"
    fxLayoutAlign.gt-md="start center"
    fxLayoutGap.gt-md="10px">

    <mat-select [(ngModel)]="selectedCountry"
      (selectionChange)="selectCountry($event)">
      <mat-option [value]="resetCategory">Land auswählen</mat-option>
      <mat-option *ngFor="let country of categories"
        [value]="country"
        fxLayout="row">
        <div>{{country.name}}</div>
      </mat-option>
    </mat-select>

    <div fxHide.gt-md
      style="text-align: center;">und</div>

    <mat-select [(ngModel)]="selectedRegion"
      [disabled]="!selectedCountry"
      (selectionChange)="selectRegion($event)">
      <ng-container *ngIf="selectedCountry">
        <mat-option [value]="resetCategory">Region auswählen</mat-option>
        <mat-option *ngFor="let region of selectedCountry.children"
          [value]="region">
          {{region.name}}
        </mat-option>
      </ng-container>
    </mat-select>
  </div>

  <div fxFlex="20"
    class="reset"
    (click)="resetFilter()">
    Filter zurücksetzen
  </div>
</div>